export default {
  driver_performance_events_filters_timeFrame: "Periodo de tiempo",
  driver_performance_events_filters_events: "Eventos",
  driver_performance_events_filters_drivers: "Conductores",
  driver_performance_events_filters_tags: "Etiquetas",
  driver_performance_events_filters_configuring: "Configurando",
  driver_performance_events_filters_status: "Estado",
  driver_performance_events_filters_driverDisputed: "Conductor Desafiado",
  driver_performance_events_filters_events_helpText: "No hay eventos con video disponibles en los últimos 90 días."
};